import { AbstractControl, FormControl, UntypedFormGroup, ValidatorFn } from '@angular/forms';
import { cpf, cnpj } from 'cpf-cnpj-validator';

export class SegurancaValidador {

  static confirmacaoSenha(senha: string, confirmacao: string): ValidatorFn {
    return (formulario: UntypedFormGroup): { [key: string]: any } => {

      if (!formulario) return null;

      const senhaValue = formulario.controls[senha]?.value;
      const confirmacaoValue = formulario.controls[confirmacao]?.value;

      if (!senhaValue || !confirmacaoValue || senhaValue !== confirmacaoValue) {

        const error = { confirmacaoSenha: true };

        formulario.controls[confirmacao].setErrors(error);

        return error;
      }

      return null;

    };
  }
  static confirmacaoNovaSenha(senha: string, confirmacao: string): ValidatorFn {
    return (formulario: UntypedFormGroup): { [key: string]: any } => {

      if (!formulario) return null;

      const senhaValue = formulario.controls[senha]?.value;
      const confirmacaoValue = formulario.controls[confirmacao]?.value;

      if (senhaValue != '' && senhaValue !== confirmacaoValue) {

        const error = { confirmacaoSenha: true };

        formulario.controls[confirmacao].setErrors(error);

        return error;
      }

      return null;

    };
  }
}
